import { Typography } from "@mui/material"

import { PropTypes } from "@l2r-front/l2r-proptypes"
import { formatNumber } from "@l2r-front/l2r-utils"

import * as Styled from "./CatalogItemsCount.styled"

export function CatalogItemsCount(props) {

    const {
        className,
        formatNumbers = true,
        filteredCount,
        isMainCount,
        totalCount = null,
    } = props

    const displayFilteredCount = (Number.isInteger(filteredCount) || !formatNumbers && !!filteredCount)
    const displayTotalCount = (Number.isInteger(totalCount) || !formatNumbers && !!totalCount)

    return <Styled.Wrapper className={className} isMainCount={isMainCount}>
        {displayFilteredCount && <Styled.Text isMainCount={isMainCount} variant="Desktop & Mobile/Body/Regular">
            {formatNumbers ? formatNumber(filteredCount) : filteredCount}
        </Styled.Text>}
        {displayFilteredCount && displayTotalCount && <Typography variant="Desktop & Mobile/Body/Regular">/</Typography>}
        {displayTotalCount ? <Styled.TextTotal variant="Desktop & Mobile/Body/Small">
            {formatNumbers ? formatNumber(totalCount) : totalCount}
        </Styled.TextTotal>
            : null}
    </Styled.Wrapper>
}

CatalogItemsCount.propTypes = {
    className: PropTypes.string,
    filteredCount: PropTypes.number.isRequired,
    formatNumbers: PropTypes.bool,
    isMainCount: PropTypes.bool,
    totalCount: PropTypes.number,
}